import React from 'react';

interface ReactReadyWrapperProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Wrapper component that only renders children when React is ready
 * In Vite, React is always available, but this can be useful for hydration checks
 */
export function ReactReadyWrapper({ children, fallback = null }: ReactReadyWrapperProps) {
  // In Vite, React is always available on the client
  // This wrapper is kept for compatibility but always renders children
  return <>{children}</>;
}